import { useContext, useEffect } from "react";
import { AppContexts } from "../../providers";

const Footer = (props) => {
  const { user: account, inbox, logout } = useContext(AppContexts.AuthContext);

  return (
    <>
      <section id="hms-footer">
        {account && <span>Signed in as: {account?.user?.email || ""}</span>}
        {inbox && inbox.phone && (
          <span>
            SMS Number: {inbox.phone}
          </span>
        )}
      </section>
    </>
  );
};

export default Footer;
